import * as React from 'react';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
import { FavouriteDefinition } from 'app/types-shared';

interface FavouriteTitleProps {
  definition: FavouriteDefinition;
  translation: any;
}

export const FavouriteTitle = React.memo(({
  definition,
  translation
}: FavouriteTitleProps) => (
  <h1>
    {insertOptionalWordbreaks(
      definition.favourite.d ||
      translation.search_title
    )}
  </h1>
));
